import { ContactsTypeaheadDirectiveModule, NotesDirectiveModule } from '@b2b/common/directives';
import { LoadCssResolver, LoadScriptResolver } from '@b2b/common/resolvers';
import uiRouter, { StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import { OrdersCheckoutView } from './checkout/checkout';
import { OrdersControllerModule } from './controllers/OrdersController';
import { OrdersCreateView } from './create/create';
import { OrdersDetailView } from './detail/detail';
import { OrdersEditView } from './edit/edit';
import { OrdersListView } from './list/list';
import { OrdersModalsRequestView } from './modals/request/request';
import { OrdersPaymentView } from './payment/payment';
import { OrdersPrintView } from './print/print';
import { OrdersRefundView } from './refund/refund';

export const OrdersView = angular
  .module('acme.view.application.orders', [
    uiRouter,
    'ui.bootstrap',
    'acme.common.service.api',
    'acme.common.directive.dataGrid',
    NotesDirectiveModule,
    'acme.common.directive.spectrum',
    ContactsTypeaheadDirectiveModule,
    'acme.common.directive.datePicker',
    OrdersControllerModule,
    OrdersPrintView,
    OrdersCreateView,
    OrdersCheckoutView,
    OrdersRefundView,
    OrdersListView,
    OrdersPaymentView,
    OrdersEditView,
    OrdersDetailView,
    'acme.view.application.orders.requests',
    'acme.view.application.orders.offline',
    'acme.view.application.dataGrid.controllers',
    OrdersModalsRequestView,
  ])
  .config(function config($stateProvider: StateProvider) {
    $stateProvider.state({
      name: 'application.orders',
      url: '/orders',
      abstract: true,
      views: {
        'subview-main': {
          controller: 'OrdersController',
          templateUrl: 'views/application/views/orders/orders.tpl.html',
        },
      },
      resolve: {
        spectrum: LoadScriptResolver({ id: 'spectrum-js', url: '/assets/spectrum.min.js' }),
        spectrumCss: LoadCssResolver({ id: 'spectrum', url: '/assets/spectrum.min.css' }),
      },
    });
  }).name;
